<template>
  <div class="d-flex align-center">
    <span 
      class="mr-2 text-no-wrap text-caption"
      :class="displayRed ? 'text-pwt_red' : ''"
    >
      {{ label ? label + ' ' + Math.max(battery, 0) : Math.max(battery, 0) }}%
    </span>
    <div
      class="rounded-pill bg-grey-lighten-3 flex-grow-1 flex-shrink-1"
      :class="displayRed ? 'bg-pwt_pink_20' : 'bg-grey-lighten-3'"
      :style="`
        width: 100%;
        height: ${dense ? '12px' : '18px'};
        box-shadow: inset -2px 3px 2px rgba(0, 0, 0, 0.2);
        overflow: hidden;`"
    >
      <div
        class="rounded-pill"
        :class="displayRed ? 'bg-pwt_red' : 'bg-pwt_azure'"
        :style="{ width: `${Math.max(battery, 1)}%`, height: '100%' }"
      ></div>
    </div>
  </div>
</template>
<script setup lang="ts">
interface Props {
  battery: number
  label?: string
  dense?: boolean
  displayRed?: boolean
}

const { battery = 0, label, dense = false, displayRed = false } = defineProps<Props>()
</script>
